module.exports = __webpack_public_path__ + "static/media/step4.87ddd67f.md";


//////////////////
// WEBPACK FOOTER
// ./src/guides/step4.md
// module id = ./src/guides/step4.md
// module chunks = 0